export default __webpack_public_path__ + "static/media/sideImage4.3e3bedc0.png";